'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherPlus } from '@subframe/core';
import { useState } from 'react';
import { Alert, Button, ConfirmationModal, PageHeader_Main, SegredoExibidoUmaVezModal, Skeleton } from '@/shared/components/ui';
import { TEXTOS_DA_CHAVE_EMITIDA } from '../constants/chavesDeApi';
import { useChavesDeApi } from '../hooks/useChavesDeApi';
import type { ChaveDoCliente, EnvioDoFormulario, ModoDoFormulario } from '../types/chavesDeApiTypes';
import { fimDaSobrevida, rotuloDaChave } from '../utils/regrasDaTela';
import { FormularioDeChaveModal } from './FormularioDeChaveModal';
import { ListaDeChaves } from './ListaDeChaves';
const MOTIVO_CRIAR_DESABILITADO = 'O escritório já tem uma chave vigente. Para trocá-la sem interromper a integração, use Rotacionar.';
function textoDaRevogacao(chave: ChaveDoCliente): {
  titulo: string;
  descricao: string;
} {
  const rotulo = rotuloDaChave(chave);
  if (chave.estado === 'VIGENTE') {
    return {
      titulo: 'Revogar a chave vigente?',
      descricao: `A integração do escritório para na hora: todo pedido com ${rotulo} passa a ser recusado, e o escritório fica sem chave até criar outra. Para trocar a chave sem interromper a integração, use Rotacionar.`
    };
  }
  const fim = fimDaSobrevida(chave);
  return {
    titulo: 'Revogar a chave agora?',
    descricao: `${rotulo} deixa de funcionar na hora${fim ? `, sem esperar ${fim}` : ''}. Se o sistema do escritório ainda a usa, a integração para.`
  };
}
export function ChavesDeApiView() {
  const $ = _c(58);
  const {
    carregado,
    chaves,
    carregando,
    erro,
    acaoEmCurso,
    erroDaAcao,
    temChaveVigente,
    recarregar,
    criar,
    rotacionar,
    revogar,
    limparErroDaAcao
  } = useChavesDeApi();
  const [formulario, setFormulario] = useState(null);
  const [aberturas, setAberturas] = useState(0);
  const [chaveParaRevogar, setChaveParaRevogar] = useState(null);
  const [textoEmitido, setTextoEmitido] = useState(null);
  let t0;
  if ($[0] !== limparErroDaAcao) {
    t0 = modo => {
      limparErroDaAcao();
      setAberturas(_temp);
      setFormulario(modo);
    };
    $[0] = limparErroDaAcao;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const abrirFormulario = t0;
  let t1;
  if ($[2] !== limparErroDaAcao) {
    t1 = () => {
      limparErroDaAcao();
      setFormulario(null);
    };
    $[2] = limparErroDaAcao;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const fecharFormulario = t1;
  let t2;
  if ($[4] !== criar || $[5] !== rotacionar) {
    t2 = async envio => {
      const texto = envio.tipo === "criar" ? await criar(envio.dados) : await rotacionar(envio.chave.id, envio.dados);
      if (texto) {
        setFormulario(null);
        setTextoEmitido(texto);
      }
    };
    $[4] = criar;
    $[5] = rotacionar;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const enviarFormulario = t2;
  let t3;
  if ($[7] !== limparErroDaAcao) {
    t3 = chave => {
      limparErroDaAcao();
      setChaveParaRevogar(chave);
    };
    $[7] = limparErroDaAcao;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const abrirRevogacao = t3;
  let t4;
  if ($[9] !== chaveParaRevogar || $[10] !== revogar) {
    t4 = async () => {
      if (!chaveParaRevogar) {
        return;
      }
      await revogar(chaveParaRevogar.id);
      setChaveParaRevogar(null);
    };
    $[9] = chaveParaRevogar;
    $[10] = revogar;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const confirmarRevogacao = t4;
  let t5;
  if ($[12] !== chaveParaRevogar) {
    t5 = chaveParaRevogar ? textoDaRevogacao(chaveParaRevogar) : null;
    $[12] = chaveParaRevogar;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const revogacao = t5;
  const criarDesabilitado = !carregado || temChaveVigente || acaoEmCurso !== null;
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FeatherPlus />;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== abrirFormulario) {
    t7 = () => abrirFormulario({
      tipo: "criar"
    });
    $[15] = abrirFormulario;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== criarDesabilitado || $[18] !== t7) {
    t8 = <Button variant="brand-primary" icon={t6} disabled={criarDesabilitado} onClick={t7}>Criar chave</Button>;
    $[17] = criarDesabilitado;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== carregado || $[21] !== temChaveVigente) {
    t9 = carregado && temChaveVigente && <span className="text-subtext-color max-w-xs text-right text-xs">{MOTIVO_CRIAR_DESABILITADO}</span>;
    $[20] = carregado;
    $[21] = temChaveVigente;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <PageHeader_Main title="Chaves de API" subtitle={"Chaves que o sistema do escrit\xF3rio usa para acessar a API da Arbitralis."} actions={<div className="flex flex-col items-end gap-1">{t8}{t9}</div>} />;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== erroDaAcao || $[27] !== formulario) {
    t11 = erroDaAcao && !formulario && <Alert variant="error" title={"N\xE3o foi poss\xEDvel concluir"} description={erroDaAcao.mensagem} />;
    $[26] = erroDaAcao;
    $[27] = formulario;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== abrirFormulario || $[30] !== abrirRevogacao || $[31] !== acaoEmCurso || $[32] !== carregado || $[33] !== carregando || $[34] !== chaves || $[35] !== erro || $[36] !== recarregar) {
    t12 = erro ? <Alert variant="error" title={"N\xE3o foi poss\xEDvel carregar as chaves"} description={erro.mensagem} actions={<Button variant="neutral-secondary" size="small" onClick={() => void recarregar()}>Tentar novamente</Button>} /> : !carregado && carregando ? <div className="flex w-full flex-col gap-2" aria-busy="true"><Skeleton className="h-12 w-full" /><Skeleton className="h-12 w-full" /></div> : carregado ? <ListaDeChaves chaves={chaves} acoesDesabilitadas={acaoEmCurso !== null} onRotacionar={chave_0 => abrirFormulario({
      tipo: "rotacionar",
      chave: chave_0
    })} onRevogar={abrirRevogacao} /> : null;
    $[29] = abrirFormulario;
    $[30] = abrirRevogacao;
    $[31] = acaoEmCurso;
    $[32] = carregado;
    $[33] = carregando;
    $[34] = chaves;
    $[35] = erro;
    $[36] = recarregar;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== aberturas || $[39] !== acaoEmCurso || $[40] !== enviarFormulario || $[41] !== erroDaAcao || $[42] !== fecharFormulario || $[43] !== formulario) {
    t13 = formulario && <FormularioDeChaveModal key={aberturas} modo={formulario} enviando={acaoEmCurso === "criar" || acaoEmCurso === "rotacionar"} erro={erroDaAcao} onFechar={fecharFormulario} onEnviar={dados => void enviarFormulario(dados)} />;
    $[38] = aberturas;
    $[39] = acaoEmCurso;
    $[40] = enviarFormulario;
    $[41] = erroDaAcao;
    $[42] = fecharFormulario;
    $[43] = formulario;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== textoEmitido) {
    t14 = textoEmitido && <SegredoExibidoUmaVezModal texto={textoEmitido} textos={TEXTOS_DA_CHAVE_EMITIDA} onFechar={() => setTextoEmitido(null)} />;
    $[45] = textoEmitido;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  let t15;
  if ($[47] !== acaoEmCurso || $[48] !== confirmarRevogacao || $[49] !== revogacao) {
    t15 = revogacao && <ConfirmationModal isOpen={true} onOpenChange={aberto => {
      if (!aberto && acaoEmCurso !== "revogar") {
        setChaveParaRevogar(null);
      }
    }} variant="destructive" title={revogacao.titulo} description={revogacao.descricao} confirmText="Revogar agora" loading={acaoEmCurso === "revogar"} onConfirm={() => void confirmarRevogacao()} />;
    $[47] = acaoEmCurso;
    $[48] = confirmarRevogacao;
    $[49] = revogacao;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] !== t10 || $[52] !== t11 || $[53] !== t12 || $[54] !== t13 || $[55] !== t14 || $[56] !== t15) {
    t16 = <div className="flex min-h-screen w-full flex-col gap-6 p-8">{t10}{t11}{t12}{t13}{t14}{t15}</div>;
    $[51] = t10;
    $[52] = t11;
    $[53] = t12;
    $[54] = t13;
    $[55] = t14;
    $[56] = t15;
    $[57] = t16;
  } else {
    t16 = $[57];
  }
  return t16;
}
function _temp(n) {
  return n + 1;
}